import { Skeleton } from 'antd';

export const DeckDetailSkeleton = () => {
  return (
    <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 space-y-6">
      {/* En-tête du Deck Skeleton */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="p-6">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-3">
                <Skeleton.Avatar active size={48} />
                <div className="flex-1">
                  <Skeleton.Input active size="large" className="!w-[300px] !mb-2" />
                  <div className="flex gap-4">
                    <Skeleton.Input active size="small" className="!w-[100px]" />
                    <Skeleton.Input active size="small" className="!w-[120px]" />
                    <Skeleton.Input active size="small" className="!w-[80px]" />
                  </div>
                </div>
              </div>
            </div>
            <Skeleton.Button active size="large" className="!w-[120px]" />
          </div>

          {/* Description Skeleton */}
          <div className="mt-6 bg-gray-50 rounded-lg p-4">
            <Skeleton active paragraph={{ rows: 3 }} />
          </div>
        </div>
      </div>

      {/* Section Votes Skeleton */}
      <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-indigo-100">
        <div className="border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 p-4">
          <Skeleton.Input active size="small" className="!w-[200px] !bg-white/20" />
        </div>
        <div className="flex flex-col sm:flex-row items-stretch divide-y sm:divide-y-0 sm:divide-x divide-gray-200">
          <div className="p-6 flex-1">
            <div className="flex flex-col items-center gap-4">
              <Skeleton.Input active size="small" className="!w-[100px]" />
              <Skeleton.Input active size="large" className="!w-[80px]" />
              <Skeleton active paragraph={{ rows: 1 }} className="!w-[150px]" />
            </div>
          </div>
          <div className="p-6 flex-1">
            <div className="flex flex-col items-center gap-4">
              <Skeleton.Input active size="small" className="!w-[120px]" />
              <div className="flex gap-2">
                <Skeleton.Button active size="large" className="!w-[100px]" />
                <Skeleton.Button active size="large" className="!w-[100px]" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Liste des Cartes Skeleton */}
      <div className="bg-white rounded-2xl shadow-md p-8 border border-indigo-100">
        <Skeleton.Input active size="large" className="!w-[200px] !mb-6" />
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
          {[...Array(12)].map((_, index) => (
            <div key={index} className="flex flex-col">
              <Skeleton.Image active className="!w-full !aspect-[3/4]" />
              <div className="mt-2">
                <Skeleton.Input active size="small" className="!w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Section Analyse Skeleton */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="border-b border-gray-200 p-4">
          <Skeleton.Input active size="small" className="!w-[200px]" />
          <div className="mt-2">
            <Skeleton active paragraph={{ rows: 2 }} />
          </div>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="border-b border-gray-200 bg-gray-50 p-4">
                  <Skeleton.Input active size="small" className="!w-[150px]" />
                </div>
                <div className="p-4 space-y-2">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="flex justify-between items-center p-2">
                      <Skeleton.Input active size="small" className="!w-[100px]" />
                      <Skeleton.Input active size="small" className="!w-[60px]" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}; 